
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_10m3l_q0do4_97",
  "token": "awsui_token_10m3l_q0do4_102",
  "show-operation": "awsui_show-operation_10m3l_q0do4_113",
  "select": "awsui_select_10m3l_q0do4_119",
  "token-content": "awsui_token-content_10m3l_q0do4_123",
  "dismiss-button": "awsui_dismiss-button_10m3l_q0do4_127",
  "token-disabled": "awsui_token-disabled_10m3l_q0do4_163"
};
  